import { enableProdMode, importProvidersFrom } from '@angular/core';


import { NgOptimizedImage } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AuthModule } from '@auth0/auth0-angular';
import { NgxGoogleAnalyticsModule, NgxGoogleAnalyticsRouterModule } from 'ngx-google-analytics';
import { materialProviders } from 'src/app/material.providers';
import { AppRoutingModule } from './app/app-routing.module';
import { AppComponent } from './app/app.component';
import { httpInterceptorProviders } from './app/http-interceptors';
import { providers } from './app/providers';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(BrowserModule, NgOptimizedImage, AuthModule.forRoot(environment.auth0), ...(environment.ga
            ? [
                NgxGoogleAnalyticsModule.forRoot(environment.ga.trackingCode),
                NgxGoogleAnalyticsRouterModule.forRoot(environment.ga.routing),
            ]
            : []), ReactiveFormsModule, AppRoutingModule,HttpClientModule),
        httpInterceptorProviders, providers, materialProviders,
        provideAnimations(),
    ]
})
  .catch((err) => {
    console.error(err);
  });
